/* =========================
   Karriere – Job Detail (JS Render)
========================= */
(function () {
  const root = document.getElementById("kcl-job-detail-root");
  const dataEl = document.getElementById("kcl-jobs-json");

  if (!root || !dataEl) return;

  function getQueryParam(name) {
    const params = new URLSearchParams(window.location.search);
    return params.get(name) || "";
  }

  function escapeHtml(str) {
    return String(str || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  let data;
  try {
    data = JSON.parse(dataEl.textContent || "{}");
  } catch (e) {
    root.innerHTML = `<p class="kcl-richtext">Fehler beim Laden der Stelle.</p>`;
    return;
  }

  const jobHandle = getQueryParam("job").trim();
  const jobs = Array.isArray(data.jobs) ? data.jobs : [];

  if (!jobHandle) {
    root.innerHTML = `
      <h1 class="kcl-job-detail__title">Stelle nicht gefunden</h1>
      <p class="kcl-richtext">Kein Job-Parameter in der URL gefunden.</p>
      <a class="kcl-btn" href="/pages/offene-stellen">Zur Übersicht</a>
    `;
    return;
  }

  const job = jobs.find((j) => j.handle === jobHandle);

  if (!job) {
    root.innerHTML = `
      <h1 class="kcl-job-detail__title">Stelle nicht gefunden</h1>
      <p class="kcl-richtext">Die Stelle ist nicht verfügbar oder der Link ist ungültig.</p>
      <a class="kcl-btn" href="/pages/offene-stellen">Zur Übersicht</a>
    `;
    return;
  }

  if (job.is_active !== true) {
    root.innerHTML = `
      <h1 class="kcl-job-detail__title">${escapeHtml(job.title)}</h1>
      <p class="kcl-richtext">Diese Stelle ist aktuell nicht aktiv.</p>
      <a class="kcl-btn" href="/pages/offene-stellen">Zur Übersicht</a>
    `;
    return;
  }

  /* =========================
     Header Meta (nur Standort + Anstellungsart)
  ========================= */
  const metaParts = [
    job.location ? `<span class="kcl-pill">${escapeHtml(job.location)}</span>` : "",
    job.employment_type ? `<span class="kcl-pill">${escapeHtml(job.employment_type)}</span>` : ""
  ].filter(Boolean);

  /* =========================
     Bewerbungs-URL (mit Prefill)
  ========================= */
  const applyUrl = new URL("/pages/bewerbung", window.location.origin);
  applyUrl.searchParams.set("job_title", job.title || "");
  applyUrl.searchParams.set("ref_id", job.ref_id || "");
  applyUrl.searchParams.set("location", job.location || "");
  applyUrl.searchParams.set("category", job.category || "");
  applyUrl.searchParams.set("department", job.department || "");
  applyUrl.searchParams.set("job_handle", job.handle || "");
  applyUrl.searchParams.set("from_url", window.location.href);

  root.innerHTML = `
    <div class="kcl-job-detail">
      <header class="kcl-job-detail__head">
        <h1 class="kcl-job-detail__title">${escapeHtml(job.title)}</h1>

        <div class="kcl-job-card__meta">
          ${metaParts.join("")}
        </div>

        ${job.intro_html ? `<div class="kcl-richtext">${job.intro_html}</div>` : ""}
      </header>

      <div class="kcl-job-detail__grid">
        <main class="kcl-panel">
          ${job.excerpt ? `
            <p class="kcl-job-detail__excerpt">${escapeHtml(job.excerpt)}</p>
          ` : ""}

          ${job.responsibilities_html ? `
            <h2 class="kcl-panel__title">Aufgaben</h2>
            <div class="kcl-richtext">${job.responsibilities_html}</div>
          ` : ""}

          ${job.requirements_html ? `
            <h2 class="kcl-panel__title" style="margin-top:1.5rem;">Anforderungen</h2>
            <div class="kcl-richtext">${job.requirements_html}</div>
          ` : ""}

          ${job.benefits_html ? `
            <h2 class="kcl-panel__title" style="margin-top:1.5rem;">Benefits</h2>
            <div class="kcl-richtext">${job.benefits_html}</div>
          ` : ""}
        </main>

        <aside class="kcl-panel">
          <h2 class="kcl-panel__title">Bewerbung</h2>
          <a class="kcl-btn" href="${applyUrl.toString()}">Jetzt bewerben</a>
          <p class="kcl-cta__note">Deine Angaben werden ausschließlich zur Bearbeitung deiner Bewerbung verwendet.</p>
        </aside>
      </div>
    </div>
  `;
})();
